/**
 * Открывает внешнюю ссылку в системном браузере, а не внутри PWA WebView.
 * Для PWA в standalone-режиме window.open(url, '_system') открывает системный браузер.
 * Если браузер не поддерживает '_system', открывается в новой вкладке.
 */
export function openExternal(url: string): void {
  // Проверяем, что это внешняя ссылка (не относительная)
  try {
    const parsed = new URL(url, window.location.origin);
    // Если протокол или хост отличаются от текущего — это внешняя ссылка
    if (parsed.protocol !== window.location.protocol || parsed.host !== window.location.host) {
      window.open(url, '_system', 'noopener,noreferrer');
      return;
    }
  } catch {
    // Если URL невалидный — пробуем открыть как есть
  }
  // Для относительных ссылок — стандартное поведение
  window.open(url, '_blank');
}

/**
 * Проверяет, является ли ссылка внешней (ведёт на другой домен).
 */
export function isExternal(url: string): boolean {
  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.protocol !== window.location.protocol || parsed.host !== window.location.host;
  } catch {
    return false;
  }
}

/**
 * Глобальный обработчик кликов для перехвата внешних ссылок.
 * Вешается один раз при монтировании приложения.
 * Не работает для ссылок внутри Shadow DOM (например, MDX Editor).
 */
export function setupExternalLinksHandler(): void {
  document.addEventListener('click', (e: MouseEvent) => {
    // Ищем ближайший <a> с href
    const anchor = (e.target as Element).closest('a');
    if (!anchor || !anchor.href) return;

    const href = anchor.getAttribute('href');
    if (!href) return;

    // Если это якорная ссылка или data-атрибут — не перехватываем
    if (href.startsWith('#') || href.startsWith('data:')) return;

    // Если пользователь зажал Ctrl/Cmd — стандартное поведение
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;

    if (isExternal(href)) {
      e.preventDefault();
      openExternal(href);
    }
  });
}
